import React from 'react';
import { List } from '@mui/material';
import { SettingsListSubheader } from 'components/Settings/SettingsListSubheader';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { SupportAndFeedbackDesktopContent } from './SupportAndFeedbackDesktopContent';
import { SupportAndFeedbackMobileContent } from './SupportAndFeedbackMobileContent';

export const SupportAndFeedback = () => {
  const { isDesktop } = useDeviceType();
  const { translation } = useTranslationContext();

  return (
    <List
      aria-labelledby="support_and_feedback_settings-header"
      className="support-and-feedback"
      data-testid="support-and-feedback-section"
    >
      <SettingsListSubheader
        isDesktop={isDesktop}
        id="support_and_feedback_settings-header"
        aria-label={translation('support_and_feedback')}
      >
        {translation('support_and_feedback')}
      </SettingsListSubheader>
      {isDesktop ? <SupportAndFeedbackDesktopContent /> : <SupportAndFeedbackMobileContent />}
    </List>
  );
};
